/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Embed_Export_Select_Ad_FailedInputs */



/**
* | output |
* | --- |
* | "Error selecting AD audio file" |
*
* @param {Audio_Embed_Export_Select_Ad_FailedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_embed_export_select_ad_failed = /** @type {((inputs?: Audio_Embed_Export_Select_Ad_FailedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Embed_Export_Select_Ad_FailedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Erreur lors de la sélection du fichier audio AD")
	if (locale === "de") return /** @type {LocalizedString} */ ("Fehler bei der Auswahl der AD-Audiodatei")
	if (locale === "it") return /** @type {LocalizedString} */ ("Errore durante la selezione del file audio AD")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Ошибка при выборе аудиофайла AD")
	if (locale === "es") return /** @type {LocalizedString} */ ("Error al seleccionar el archivo de audio AD")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("选择 AD 音频文件时出错")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ADオーディオファイルの選択エラー")
	if (locale === "hi") return /** @type {LocalizedString} */ ("AD ऑडियो फ़ाइल का चयन करने में त्रुटि")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Erro ao selecionar o arquivo de áudio AD")
	return /** @type {LocalizedString} */ ("Error selecting AD audio file")
});